import nBossConnection from 'modules/base/service/nBossConnection';

class KerdesService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'kerdesControl';
	}

	/**
	 * @param {questionId} questionId
	 * @return {Promise<String>}
	 */
	showQuestion(questionId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/showQuestion`, { questionId })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new KerdesService();